import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "user-login" }
const _hoisted_2 = {
  key: 0,
  class: "arco-upload-list-picture custom-upload-avatar"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "arco-upload-list-picture-mask" }
const _hoisted_5 = {
  key: 1,
  class: "arco-upload-picture-card"
}
const _hoisted_6 = { class: "arco-upload-picture-card-text" }
const _hoisted_7 = { style: {"margin-top":"10px","font-weight":"600","width":"128px","height":"128px"} }
const _hoisted_8 = ["src"]

import { computed, onMounted, ref } from "vue";
import {
  FileControllerService,
  UserControllerService,
  UserVO,
} from "../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import {
  IconEmail,
  IconFile,
  IconIdcard,
  IconPhone,
  IconUser,
} from "@arco-design/web-vue/es/icon";
import ACCESSENUM from "@/access/accessEnum";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserEditView',
  setup(__props) {

const router = useRouter();
const store = useStore();
const currUser = computed(() => {
  return store.state.user;
});
const form = ref({
  userId: "",
  userName: "",
  userAvatar:
    "https://q.qlogo.cn/headimg_dl?dst_uin=3134210778&spec=640&img_type=jpg",
  userProfile: "",
  userPhone: "",
  userMail: "",
});
const loadData = async () => {
  const route = useRoute();
  const userId = route.params.id;
  const res = await UserControllerService.getUserVoByIdUsingGet(userId as any);
  if (res.code === 0) {
    form.value.userId = res.data?.userId as any;
    form.value.userName = res.data?.userName as string;
    form.value.userAvatar = res.data?.userAvatar as string;
    form.value.userProfile = res.data?.userProfile as string;
    // 隐私处理
    form.value.userPhone = res.data?.userPhone as string;
    form.value.userMail = res.data?.userMail as string;
  } else {
    message.error("加载失败！ " + res.message);
  }
};
onMounted(() => {
  loadData();
});

const file = ref();

// 节流：记录上次上传时间，2s 内只允许一次上传
const lastUploadTime = ref<number>(0);

const doUpload = async (currentFile: any) => {
  // 校验是否为图片
  const isImage = currentFile.file?.type?.startsWith("image/");
  if (!isImage) {
    message.error("只能上传图片文件！");
    return;
  }

  // 显示上传中状态
  file.value = {
    ...currentFile,
    status: "uploading",
    percent: currentFile.percent ?? 0,
  };

  const res = await FileControllerService.uploadFileUsingPost(
    currentFile.file,
    "user_avatar"
  );
  if (res.code === 0) {
    form.value.userAvatar = res.data as string;
    message.success("上传成功！");
    file.value = {
      ...currentFile,
      url: form.value.userAvatar,
      status: "done",
      percent: 100,
    };
  } else {
    message.error("上传失败！" + res.message);
    file.value = {
      ...currentFile,
      status: "error",
    };
  }
};

const onChange = async (_: any, currentFile: any) => {
  const now = Date.now();
  if (now - lastUploadTime.value < 2000) {
    return;
  }
  lastUploadTime.value = now;
  await doUpload(currentFile);
};
const onProgress = (currentFile: any) => {
  file.value = currentFile;
};
const handleSubmit = (data: UserVO) => {
  console.log(data);
};
const submit = async () => {
  let res: any;
  if (currUser.value.loginUser.userRole === "admin") {
    res = await UserControllerService.updateUserUsingPost({
      ...(form.value as any),
    });
  } else {
    res = await UserControllerService.updateMyUserUsingPost({
      ...form.value,
    });
  }
  if (res.code === 0) {
    message.success("修改成功！");
  } else {
    message.error("修改失败！" + res.message);
  }
};
const cancel = () => {
  router.back();
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_IconEdit = _resolveComponent("IconEdit")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("h2", { style: {"margin-bottom":"32px"} }, "用户信息修改", -1)),
    _createVNode(_component_a_form, {
      "label-align": 'right',
      layout: _ctx.horizontal,
      model: form.value,
      "auto-label-width": "",
      style: {"max-width":"480px","margin":"0 auto"},
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        (currUser.value.loginUser.userRole === _unref(ACCESSENUM).ADMIN)
          ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 0,
              field: "userName",
              label: "用户ID"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: form.value.userId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.userId) = $event)),
                  "max-length": { length: 20, errorOnly: true },
                  disabled: ""
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_unref(IconIdcard))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form_item, {
          field: "userName",
          label: "昵称"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.userName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.userName) = $event)),
              "max-length": { length: 20, errorOnly: true }
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(IconUser))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userAvatar",
          label: "头像"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_upload, {
              fileList: file.value ? [file.value] : [],
              "show-file-list": false,
              action: "/",
              style: {"height":"128px"},
              onChange: onChange,
              onProgress: onProgress
            }, {
              "upload-button": _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(`arco-upload-list-item${
                file.value && file.value.status === 'error'
                  ? ' arco-upload-list-item-error'
                  : ''
              }`)
                }, [
                  (file.value && file.value.url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("img", {
                          src: form.value.userAvatar,
                          alt: "头像"
                        }, null, 8, _hoisted_3),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_IconEdit)
                        ]),
                        (file.value.status === 'uploading' && file.value.percent < 100)
                          ? (_openBlock(), _createBlock(_component_a_progress, {
                              key: 0,
                              percent: file.value.percent,
                              style: {
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translateX(-50%) translateY(-50%)',
                  },
                              size: "mini",
                              type: "circle"
                            }, null, 8, ["percent"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("img", {
                              src: form.value.userAvatar,
                              alt: "头像",
                              style: {"width":"128px"}
                            }, null, 8, _hoisted_8)
                          ])
                        ])
                      ]))
                ], 2)
              ]),
              _: 1
            }, 8, ["fileList"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userProfile",
          label: "简介"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.userProfile,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.userProfile) = $event)),
              "max-length": { length: 50, errorOnly: true },
              "allow-clear": "",
              "show-word-limit": ""
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(IconFile))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userPhone",
          label: "手机"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.userPhone,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.userPhone) = $event)),
              "max-length": { length: 20, errorOnly: true }
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(IconPhone))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userMail",
          label: "邮箱"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.userMail,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.userMail) = $event)),
              "max-length": { length: 20, errorOnly: true }
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(IconEmail))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["layout", "model"]),
    _createVNode(_component_a_button, {
      size: 'large',
      type: "primary",
      onClick: submit
    }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [
        _createTextVNode("提交")
      ])),
      _: 1
    }),
    _createVNode(_component_a_button, {
      size: 'large',
      style: {"margin-left":"1rem"},
      type: "primary",
      onClick: cancel
    }, {
      default: _withCtx(() => _cache[6] || (_cache[6] = [
        _createTextVNode("返回 ")
      ])),
      _: 1
    })
  ]))
}
}

})